<template>
  <v-container max-width="600px">
    <v-card class="pa-6">
      <v-card-title>문의하기</v-card-title>
      <v-divider />
      <v-card-text>
        <v-form  ref="form" v-model="valid">
          <v-text-field dense outlined v-model="form.name" label="이름" required></v-text-field>
          <v-text-field dense outlined v-model="form.email" label="이메일" required type="email"></v-text-field>
          <v-text-field dense outlined v-model="form.phone" label="전화번호" required></v-text-field>
          <v-text-field dense outlined v-model="form.subject" label="제목" required></v-text-field>
          <v-textarea dense outlined v-model="form.message" label="문의내용" required></v-textarea>
          <v-file-input  dense outlined v-model="form.attachment" label="첨부파일" prepend-icon="mdi-paperclip"></v-file-input>
          <!--사람임을 인증하기 위해서 문구를 만들기-->
          <v-text-field
            dense outlined
            v-model="form.captcha_answer"
            :label="captchaQuestion"
            required
          >
            <template v-slot:append-outer>
              <v-btn icon small @click="loadCaptcha" :title="'다시 불러오기'">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn block :disabled="!valid" color="black" class="white--text" @click="submitForm">제출</v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      valid: false,
      captchaId: '',
      captchaQuestion: '',
      snackbar: false,
      snackbarMessage: '',
      form: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        attachment: null,
        captcha_answer: ''
      }
    };
  },
  mounted() {
    this.loadCaptcha();
  },
  methods: {
    async loadCaptcha() {
       try {
         const res = await axios.get('api/company-contact/captcha/');
         this.captchaId = res.data.captcha_id;
         console.log(this.captchaId)
         this.captchaQuestion = res.data.question;
         console.log(this.captchaQuestion)
         this.form.captcha_answer = '';
       } catch (e) {
         this.snackbarMessage = '캡차를 불러오는 데 실패했습니다.';
         this.snackbar = true;
       }
     },
    async submitForm() {
      const formData = new FormData();
      for (let key in this.form) {
        if (this.form[key]) formData.append(key, this.form[key]);
      }
      formData.append('captcha_id', this.captchaId);

      try {
        await axios.post('/api/company-contact/', formData);
        this.snackbarMessage = '문의가 성공적으로 접수되었습니다.';
        this.snackbar = true;
        this.$refs.form.reset();
        this.loadCaptcha();
      } catch (error) {
        this.snackbarMessage = error.response?.data?.error || '제출 실패';
        this.snackbar = true;
      }
    }
  }
};
</script>

<style scoped>
.v-container {
  margin-top: 40px;
}
</style>
